import { SpacingsValues } from '@picsart/cascade';
import { createUseStyles } from 'react-jss';

import { ITheme, mediaQuery } from '../../../styles';

const useStyles = createUseStyles(
  ({ breakpoints }: ITheme) => ({
    root: {
      backgroundColor: 'var(--x-bg-5)',
      paddingBlock: SpacingsValues.s56,
    },
    container: {
      marginInline: 'auto',
      position: 'relative',
      width: 'min(100%, var(--max-width-02))',
    },
    title: {
      fontWeight: 500,
      marginBottom: SpacingsValues.s48,
      marginInline: 'auto',
      maxWidth: 'min(870px, calc(100% - 24px))',
      textAlign: 'center',

      [mediaQuery(breakpoints.laptop)]: {
        marginInline: SpacingsValues.s24,
      },
      [mediaQuery(breakpoints.mobile)]: {
        fontSize: 30,
        lineHeight: '36px',
        marginBottom: 40,
      },
    },

    btnContainer: {
      position: 'absolute',
      width: '100%',

      [mediaQuery(breakpoints.desktop)]: {
        display: 'none',
      },
    },
    toLeftBtn: {
      position: 'absolute',
      left: 16,
    },
    toRightBtn: {
      position: 'absolute',
      right: 16,
    },

    contentContainer: {
      width: '100%',
    },

    content: {
      display: 'flex',
      gap: SpacingsValues.s24,
      listStyleType: 'none',
      scrollbarWidth: 'none',
      scrollBehavior: 'smooth',
      transition: 'margin-left 0.4s ease-out',

      [mediaQuery(breakpoints.desktop)]: {
        overflowX: 'auto',
      },

      '&::-webkit-scrollbar': {
        display: 'none',
      },
    },
    item: {
      flexShrink: 0,
      width: 'min(312px, calc(100% - 54px))',

      [mediaQuery(1490)]: {
        '&:first-child': {
          marginLeft: 24,
        },
        '&:last-child': {
          marginRight: 24,
        },
      },
    },

    img: {
      marginBottom: SpacingsValues.s24,
      maxWidth: '100%',
    },
    itemTitle: {
      fontWeight: 600,
      marginBottom: 4,
    },
    cta: {
      marginTop: SpacingsValues.s48,
      textAlign: 'center',

      [mediaQuery(breakpoints.mobile)]: {
        display: 'none',
        marginTop: 0,
      },
    },
  }),
  {
    name: 'ImageWithTextScrollable',
  },
);

export default useStyles;
